import api from "@/lib/api";

// Friendly screen names for route changes (first match wins).
const SCREEN_NAMES = [
  [/^\/dashboard/, "Dashboard"],
  [/^\/leads\/pipeline/, "Pipeline"],
  [/^\/leads\/review/, "Review Queue"],
  [/^\/leads/, "Leads"],
  [/^\/activities/, "Activities"],
  [/^\/automation\/pipeline-settings/, "Pipeline Settings"],
  [/^\/automation\/lead-qualification/, "Lead Qualification"],
  [/^\/automation\/stage-rules/, "Stage Rules"],
  [/^\/automation\/assignment-rules/, "Assignment Rules"],
  [/^\/automation\/deal-forms/, "Deal Forms"],
  [/^\/automation\/operations-sla/, "Operations & SLA"],
  [/^\/automation\/meta-ads/, "Meta Ads"],
  [/^\/automation/, "Automation"],
  [/^\/reports\/meta-performance/, "Meta Performance"],
  [/^\/reports\/fairness/, "Fairness Report"],
  [/^\/reports/, "Reports"],
  [/^\/meetings/, "Meetings"],
  [/^\/import/, "Import Center"],
  [/^\/team\/timesheets/, "Timesheets"],
  [/^\/team/, "Team"],
  [/^\/recycle/, "Recycle Bin"],
  [/^\/settings/, "Settings"],
  [/^\/notifications/, "Notifications"],
];

export const screenName = (path) => {
  for (const [re, name] of SCREEN_NAMES) if (re.test(path)) return name;
  return path || "App";
};

// Short-window dedupe so React StrictMode double-mounts / rapid repeats don't spam the log.
let _last = { key: "", t: 0 };

export const logAudit = (body) => {
  const key = `${body.action_type}|${body.lead_id || ""}|${body.entity_id || ""}|${body.metadata?.path || ""}`;
  const now = Date.now();
  if (key === _last.key && now - _last.t < 2500) return;
  _last = { key, t: now };
  api.post("/audit/event", body).catch(() => {});
};

export const logPageView = (path) =>
  logAudit({ action_type: "page_opened", entity_type: "page", description: `Opened ${screenName(path)}`, metadata: { path } });

export const logLeadOpened = (leadId, name, from) =>
  logAudit({ action_type: "lead_drawer_opened", entity_type: "lead", lead_id: leadId, description: `Opened lead${name ? ` ${name}` : ""}${from ? ` from ${from}` : ""}` });

export const logSearch = (q) =>
  logAudit({ action_type: "search_performed", entity_type: "ui", description: `Searched "${String(q || "").slice(0, 60)}"`, metadata: { q } });

export const logFiltersApplied = (module) =>
  logAudit({ action_type: "filters_applied", entity_type: "ui", description: `Applied filters on ${module || "list"}`, metadata: { module } });

export const logStageChangeOpened = (leadId) =>
  logAudit({ action_type: "change_stage_opened", entity_type: "lead", lead_id: leadId, description: "Opened change-stage" });
